<template lang="pug">
.sponsor-card(@click="openDetails" :class="{ 'has-action': hasMoreDetails }")
    picture
        img(v-if="logo" :srcset="`${logo} 2x`" :alt="title" @error="logo = null")
        sponsor-placeholder-image(v-else)

    .details
        .title {{ title }}

    .level(v-if="sponsor.level" :style="{ color: sponsor.level.text_color, 'background-color': sponsor.level.level_color }")
        | {{ sponsorLevel }}
</template>
<script>
// Mixins
import translatable from '@/components/registration/sections/translatable.mixin.js';

// Components
import SponsorDetails from '@/components/registration/sections/SponsorDetails.vue';
import SponsorPlaceholderImage from '@/components/registration/sections/SponsorPlaceholderImage.vue';

export default {
    name: 'SponsorCard',

    mixins: [translatable],

    components: { SponsorPlaceholderImage },

    props: {
        sponsor: {
            type: Object,
            required: true
        }
    },

    data() {
        return {
            logo: this.sponsor.logo,
            translatable_object: this.sponsor
        }
    },

    computed: {
        hasMoreDetails() {
            const location = this.getT9Label('location');
            const website = this.getT9Label('website');
            const email = this.getT9Label('email');
            const description = this.getT9Label('description');

            return [location, website, email, description].some(d => Boolean((d || '').trim().length));
        },

        sponsorLevel() {
            return this.getT9Label('title', this.sponsor.level)
        }
    },

    methods: {
        openDetails() {
            if (!this.hasMoreDetails) {
                return;
            }

            this.$modal.show(
                SponsorDetails,
                {
                    config: this.config,
                    sponsor: this.sponsor
                },
                {
                    adaptive: true,
                    height: 'auto',
                    maxWidth: 584,
                    width: '90%'
                }
            );
        }
    }
};
</script>
